var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookshelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80469 3.41858L5.80469 21.1543C5.80469 21.5995 6.16562 21.9604 6.61086 21.9604C7.05609 21.9604 7.41702 21.5995 7.41702 21.1543L7.41702 3.41858C7.41702 2.97334 7.05609 2.61241 6.61086 2.61241C6.16562 2.61241 5.80469 2.97334 5.80469 3.41858Z",
    fill: "#A1A0A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9137 6.6135L9.3939 20.9041C9.31658 21.3425 9.60936 21.7607 10.0478 21.838C10.4863 21.9153 10.9044 21.6225 10.9817 21.1841L13.5016 6.89348C13.5789 6.45501 13.2861 6.03689 12.8476 5.95957C12.4092 5.88226 11.991 6.17503 11.9137 6.6135Z",
    fill: "#A1A0A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33498 6.60046L0.0702622 21.0563C0.0314575 21.4998 0.35956 21.8908 0.803101 21.9296C1.24664 21.9684 1.63766 21.6403 1.67646 21.1968L2.94118 6.74099C2.97999 6.29745 2.65188 5.90643 2.20834 5.86762C1.7648 5.82882 1.37379 6.15692 1.33498 6.60046Z",
    fill: "#A1A0A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 9.86792V21.1543C15.4785 21.5995 15.8394 21.9604 16.2847 21.9604C16.7299 21.9604 17.0909 21.5995 17.0909 21.1543V9.86792C17.0909 9.42269 16.7299 9.06176 16.2847 9.06176C15.8394 9.06176 15.4785 9.42269 15.4785 9.86792Z",
    fill: "#A1A0A5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7029,
    cy: 6.91183,
    r: 5.9119,
    transform: "rotate(-90 18.7029 6.91183)",
    fill: "#FC4343",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf);
export default __webpack_public_path__ + "static/media/Bookshelf.a70a8314f83888cfd8c1ddcbc47f3c69.svg";
export { ForwardRef as ReactComponent };